<template>
    <div>
        <a-modal v-model="isVisible" 
                :title="title" 
                on-ok="handleOk"
                :closable="false"
			    wrap-class-name="full-modal"
			    width="100%"
			    :dialog-style="{ top: '10px' }"
        >

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    Close
                </a-button>
            </template>

            <div>
                <a-row :gutter="24" type="flex" align="stretch" class="header-solid h-full mb-24 category-infinite-container" >
                    <a-col :span="24" :lg="24" >
                        <a-descriptions title="Order Info">
                            <a-descriptions-item label="Customer Name">
                                {{ info.customerName }}
                            </a-descriptions-item>

                            <a-descriptions-item label="Phone">
                                {{ info.phoneNumber }}
                            </a-descriptions-item>

                            <a-descriptions-item label="Pickup number">
                                {{ info.pickupNumber }}
                            </a-descriptions-item>

                            <a-descriptions-item label="Ordered time">
                                {{ formatTime(info.createdDate) }}
                            </a-descriptions-item>

                            <a-descriptions-item label="Pickup time">
                                {{ info.pickupTime }}
                            </a-descriptions-item>

                            <a-descriptions-item label="Amount">
                                {{ info.amount }}
                            </a-descriptions-item>

                            <a-descriptions-item label="State">
                                <a-tag color="red" v-if="info.state === 0">
                                    Pending
                                </a-tag>
                                <a-tag color="orange" v-else-if="info.state === 1">
                                    Inprogress
                                </a-tag>
                                <a-tag color="yellow" v-else-if="info.state === 2">
                                    Scheduled
                                </a-tag>
                                <a-tag color="blue" v-else-if="info.state === 3">
                                    Ready
                                </a-tag>
                                <a-tag color="orange" v-else-if="info.state === 4">
                                    Unmanaged
                                </a-tag>
                                <a-tag color="green" v-else-if="info.state === 5">
                                    Delivered
                                </a-tag>
                                <a-tag color="red" v-else-if="info.state === 6">
                                    Other
                                </a-tag>
                            </a-descriptions-item>

                            <a-descriptions-item label="Status" >
                                <a-tag color="green" v-if="info.status === 0">
                                    Confirmed
                                </a-tag>
                                <a-tag color="red" v-if="info.status === 1">
                                    Cancelled
                                </a-tag>
                                <a-tag color="orange" v-if="info.status === 2">
                                    Rejected
                                </a-tag>
                            </a-descriptions-item>

                            <a-descriptions-item label="Comment">
                                {{ info.comment}}
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
                <br/>
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="24" class="mb-24">
                        <a-card :bordered="false" 
                                class="header-solid h-full mb-24 demo-infinite-container" 
                                :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }"
                                :span="18" :lg="18" 
                                v-infinite-scroll="handleInfiniteOnload"
                                :infinite-scroll-disabled="busy"
                        >
                            <a-table class="mt-20"
				                :columns="cols"
                                :data-source="dataSource"
				                :pagination="{pageSize: pageSize}" 
				                rowKey="index"
			                >
                                <p slot="expandedRowRender" slot-scope="record" style="margin:0">
                                    {{ getOptions(record.options) }}
                                    <br/>
                                    {{ record.comment }}
                                </p>
                               
                            </a-table>         
                        </a-card>
                    </a-col>
                </a-row>
            </div>
         
        </a-modal>
       
    </div>
</template>

<script>
    import InfiniteScroll from 'v-infinite-scroll'
    import Moment from 'moment'
    const cols = [
        {
			title : 'Item Name',
			dataIndex : 'itemName',
		},
		{
			title : 'Quantity',
			dataIndex: 'quantity'
		},
        {
			title : 'Item Price',
			dataIndex : 'itemPrice',
		},
        {
			title : 'Discount',
			dataIndex : 'discount',
		},

    ];

    export default {
        directives: { InfiniteScroll },
        data () {
            return {
                cols,
                isVisible : false,
                busy: false,
                pageSize : 5,
                dataSource : [],
                info : {
                    customerName : '',
                    phoneNumber : '',
                    pickupNumber : '',
                    createdDate : ''
                },
                title: ''
            }
        },
    
        methods : {

            show(order) {
                this.dataSource = order.orderDetails;
                this.title = order.orderId;
                this.info = order;
                this.isVisible = true;
                console.log(order)
            },

            formatTime(orderedTime) {
				return Moment(orderedTime).hour() + ':' + Moment(orderedTime).minute();
			},

            getOptions(opt) {
                let options = [];
                let description = '';
                let descriptions = [];
                try {
                    options = JSON.parse(opt);
                    options.forEach(o => {
                        for(let i = 0; i< o.options.length; i++) {
                            descriptions.push(o.options[i].description);
                        }
                    });

                    for(let i = 0; i < descriptions.length; i++) {
                        if (descriptions.length - (i +1) > 0) {
                            description += descriptions[i] + ' , ';
                        }
                        else {
                            description += descriptions[i];
                        }
                    }
                }
                catch (err) {
                    console.log('Error in product options: ' + err);
                }
                finally {
                    return description;
                }
                
                
                
                

                
            },

            handleOk ()  {
                this.isVisible = false;
            },
            handleCancel () {
                this.isVisible = false;
            },
            handleInfiniteOnload() {

            },
        }
}
</script>

<style lang="scss">
	.full-modal {
  		.ant-modal {
    		max-width: 70%;
            max-height : 500px;
    		top: 50;
    		padding-bottom: 100;
    		margin: 100;
  		}
  		.ant-modal-content {
    		display: flex;
    		flex-direction: column;
    		height: calc(100vh);
  		}
  		.ant-modal-body {
    		flex: 1;
  		}
	}
</style>